import Vue from "vue";
import Vuex from "vuex";
import activationCode from "./containers/activationCode/store";
import applicationOffers from "./containers/applicationOffers/store";
import paypalContractRegister from "./containers/paypalContractRegister/store";
import paypalPaymentInformationRegister from "./containers/paypalPaymentInformationRegister/store";
import cancelContractButton from "./containers/cancelContractButton/store";
import revokeCancellationButton from "./containers/revokeCancellationButton/store";
import freeTrialRegister from "./containers/freeTrialRegister/store";
import contractAutoUpdateForm from "./containers/contractAutoUpdateForm/store";
import galaxyFreeTrialRegister from "./containers/galaxyFreeTrialRegister/store";
import google from "./containers/google/store";
import chromeFreeTrialRegister from "./containers/chromeFreeTrialRegister/store";
import lenovoFreeTrialRegister from "./containers/lenovoFreeTrialRegister/store";
import paymentInformationRegistration from "./containers/paymentInformationRegistration/store";
import common from "./containers/common/store";
import trialCampaignRegister from "./containers/trialCampaignRegister/store";
import changePlans from "./containers/changePlans/store";
import changePlansSb from "./containers/changePlansSb/store";
import sale from "./containers/sale/store";
import updatepassRegister from "./containers/updatepassRegister/store";
import updatepassPaymentInformationEditRegister from "./containers/updatepassPaymentInformationEditRegister/store";
import updatepassPaymentInformationNewRegister from "./containers/updatepassPaymentInformationNewRegister/store";
import updatepassCancelContractButton from "./containers/updatepassCancelContractButton/store";
import updatepassRevokeCancellationButton from "./containers/updatepassRevokeCancellationButton/store";
import paymentInformationRegisterStripe from "./containers/paymentInformationRegisterStripe/store";
import applicationContract from "./containers/applicationContract/store";
import cancelSurveyForm from "./containers/cancelSurveyForm/store";
import loginSharing from "./containers/loginSharing/store";
import purchaseSettlementGold from "./containers/purchaseSettlementGold/store";
import purchaseSettlementPaypal from "./containers/purchaseSettlementPaypal/store";
import pauseContract from "./containers/pauseContract/store";
import cloudContract from "./containers/cloudContract/store";
import cloudRevokeCancellationButton from "@/containers/cloudRevokeCancellationButton/store";
import cloudCancelContractButton from "./containers/cloudCancelContractButton/store";
import cloudAutoUpdateContractForm from "./containers/cloudAutoUpdateContractForm/store";
import cloudContractsChangePlans from "./containers/cloudContractsChangePlans/store";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    activationCode,
    applicationOffers,
    paypalContractRegister,
    paypalPaymentInformationRegister,
    cancelContractButton,
    revokeCancellationButton,
    contractAutoUpdateForm,
    freeTrialRegister,
    galaxyFreeTrialRegister,
    google,
    chromeFreeTrialRegister,
    lenovoFreeTrialRegister,
    paymentInformationRegistration,
    common,
    trialCampaignRegister,
    changePlans,
    changePlansSb,
    sale,
    updatepassRegister,
    updatepassPaymentInformationEditRegister,
    updatepassPaymentInformationNewRegister,
    updatepassCancelContractButton,
    updatepassRevokeCancellationButton,
    paymentInformationRegisterStripe,
    applicationContract,
    cancelSurveyForm,
    loginSharing,
    purchaseSettlementGold,
    purchaseSettlementPaypal,
    pauseContract,
    cloudContract,
    cloudRevokeCancellationButton,
    cloudCancelContractButton,
    cloudAutoUpdateContractForm,
    cloudContractsChangePlans
  },
  strict: debug
});
